var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.enabled && !!_vm.getText())?_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-sm btn-secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.navigate()}}},[_vm._v("\r\n    "+_vm._s(_vm.getText())+"\r\n  ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }